import { render, staticRenderFns } from "./danGoodsAplplyOper.vue?vue&type=template&id=5b145d4e&scoped=true"
import script from "./danGoodsAplplyOper.vue?vue&type=script&lang=js"
export * from "./danGoodsAplplyOper.vue?vue&type=script&lang=js"
import style0 from "./danGoodsAplplyOper.vue?vue&type=style&index=0&id=5b145d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b145d4e",
  null
  
)

export default component.exports